export const getAffiliationLabel = ({ name, display_name, city_label }) => {
    return `${name} ${display_name ? ` (${display_name})` : ""} ${city_label ? ` - ${city_label}` : ""}`
}

